import * as basicLightbox from 'basiclightbox';

export default () => {
  let srcolldata = sessionStorage.getItem(window.location.pathname);
  window.scrollTo(0,srcolldata);
  const buttons = document.querySelectorAll('button.btn-add');
  const product = document.querySelector('div.product');
  const message = document.getElementById('order_status');
  const photoBtn = document.querySelectorAll('.product-image');


if(photoBtn.length > 0){
  console.log(photoBtn);
  Object.keys(photoBtn).map((key) => {
    const img =
    photoBtn[key].popUp = basicLightbox.create(
        `<img src="${photoBtn[key].dataset.src}">`
    );
   photoBtn[key].addEventListener('click', photoBtn[key].popUp.show, false);
  });
}

  function handler(){
    if(this.classList.contains('btn-white')){
      removeCart(product.id, this.textContent);
    } else {
      addCart(product.id, this.textContent);
    }
  }

  Object.keys(buttons).map((key) => {
    buttons[key].addEventListener('click', handler, false);
  });

  const showMessage = (text) => {
    message.textContent = text;
    message.classList.add('active');
    setTimeout(() => {
      message.classList.remove('active');
      document.getElementById('back').click();
    }, 400);
  };

  const addCart = (id, count) => {
    const data = new FormData();
    data.append('id', id);
    data.append('count', count);
    fetch('/order/add', {
      method: 'POST',
      body: data
    })
    .then(result => result.text())
    .then((result) => {
      showMessage(result);
      Object.keys(buttons).map((key) => {
        buttons[key].classList.remove('btn-white');
      });
      buttons[count - 1].classList.add('btn-white');
    });
  };

  const removeCart = (id, count) => {
    const data = new FormData();
    data.append('id', id);
    fetch('/order/remove', {
      method: 'POST',
      body: data
    })
    .then(result => result.text())
    .then((result) => {
      showMessage(result);
      buttons[count - 1].classList.remove('btn-white');
    })
  }
};
